import Solutions from './Solutions';

export default Solutions;
